module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {

	var _ = {
		inbox: function (response) {
			var chatId;

			if (!fox.isEmpty(response.answer) && response.answer.conversationId) {
				chatId = response.answer.conversationId;

				this.total++;

				if (!this.fromUser[chatId]) {
					this.fromUser[chatId] = 1;
				} else {
					this.fromUser[chatId]++;
				}

				_.transferAmount.call(this);

				this.dispatchEvent('newInboxMessage', {
					data: response.answer,
					message: response.answer.content,
					conversationId: chatId
				});
			}
		},

		apiResponse: function (response) {
			var data;

			if (response.answer.status === true) {
				response = response.answer.response.success;

				this.total = Number(response.totalCount);
				
				fox.each(response.count, function (c, chId) {
					this.fromUser[chId] = Number(c);
				}, this);

				if (response.conversationId !== undefined) {
					fox.setEnv('site.conversationId', response.conversationId);
				}

				_.transferAmount.call(this);
			}
		},

		subMessageCount: function (chatId) {
			if (chatId !== undefined) {
				if (this.fromUser[chatId]) {
					this.total -= this.fromUser[chatId];
					this.fromUser[chatId] = 0;
					
					_.transferAmount.call(this);
					_.markMessagesAsRead.call(this, chatId);
				}
			}
		},

		transferAmount: function () {
			this.dispatchEvent('cameNewMessages', {total: this.total, fromUser: this.fromUser});
		},

		markMessagesAsRead: function (chatId) {
			return this.rwom1('#markMessagesAsReadApi').send({conversationId: chatId});
		}
	};

	fox.registerWidget('newMessageCountService', {

		configure: function () {
			this.fromUser = {};
			this.total = 0;

			this.registerOptions('', {
				subMessageCountEvent: 'readNewMessage',
				'widgets.newMessagesCountApi': {
					widget: 'Api',
					method: 'conversation.getNewMsgCount',
					useSocket: true,
					inboxSocketEvent: 'inboxSocketEventChat',
					inboxSocketCallback: fox.bind(_.inbox, this)
				},
				'widgets.markMessagesAsReadApi': {
					widget: 'Api',
					method: 'conversation.markMessagesAsRead'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			var e = this.getOption('subMessageCountEvent');

			this.handleEvent('@root', e, fox.bind(_.subMessageCount, this));

			this.callParent('init', arguments);
		},

		running: function () {
			this.wait('@root .Site_Layout', 'addedToDom')
				.then(this.fetchAmount.bind(this));
			
			this.callParent('running', arguments);
		},

		fetchAmount: function () {
			var api = this.rwom1('#newMessagesCountApi');

			return api.psend({}).then(function (resp) {
				return _.apiResponse.call(this, resp.params);
			}.bind(this));
		},

		transferAmount: function (data) {
			this.fromUser = data;

			_.transferAmount.call(this);
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/chat/widget/conversation/newMessageCountService.js
// module id = 88
// module chunks = 4